<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="page_con">
          <h1 class="con_ttl">
            <span>구독 알림 설정</span>
            <button class="btn_setting"></button>
          </h1>
          <div class="form_wrap">
            <!--      20210809 주석처리      -->
            <div class="on_list">
              <ul class="on_list_ul">
                <li class="on_list_li">
                  <div class="on_list_ttl">희망 파티 설정</div>
                  <label class="toggle_type02"
                    ><input
                      type="checkbox"
                      :true-value="'Y'"
                      :false-value="'N'"
                      v-model="params.openYn"
                      :checked="params.openYn === 'Y'"/><span></span
                  ></label>
                </li>
                <li class="on_list_li">
                  <div class="on_list_ttl">
                    알림 수신 <span class="hint">* APP에서 자동 알림</span>
                  </div>
                  <label class="toggle_type02"
                    ><input
                      type="checkbox"
                      :true-value="'Y'"
                      :false-value="'N'"
                      v-model="params.notiYn"
                      :checked="params.notiYn === 'Y'"/><span></span
                  ></label>
                </li>
              </ul>
            </div>
            <!--      20210809 주석처리      -->
            <div class="form">
              <ul class="form_ul">
                <li class="form_li">
                  <div class="form_ttl essen">카테고리</div>
                  <div class="form_in">
                    <label class="select">
                      <select v-model="params.categoryId">
                        <option :value="''">카테고리를 선택해 주세요.</option>
                        <option
                          v-for="(item, index) in category"
                          :key="index"
                          :value="item.categoryId"
                          >{{ item.categoryNm }}</option
                        >
                      </select>
                    </label>
                  </div>
                </li>
                <!-- 20210809 주석처리 -->
                <li class="form_li">
                  <div class="form_ttl essen">신청 제목</div>
                  <div class="form_in">
                    <label class="input">
                      <input
                        type="text"
                        placeholder="파티명을 입력해 주세요(100자 이내)"
                        v-model="params.title"
                        :maxlength="100"
                      />
                    </label>
                    <div class="hint">
                      휴대폰 본인인증을 진행합니다. 성인만 가입할 수 있습니다.
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl essen">이용 기간</div>
                  <div class="form_in">
                    <label class="select">
                      <select v-model="params.usePeriod">
                        <option :value="30">30일</option>
                        <option :value="60">60일</option>
                        <option :value="90">90일</option>
                        <option :value="120">120일</option>
                        <option :value="150">150일</option>
                        <option :value="365">1년 이상</option>
                      </select>
                    </label>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl essen">알림 기한</div>
                  <div class="form_in">
                    <div class="datepicker">
                      <date-picker
                        v-model="params.notiDt"
                        :masks="{
                          input: 'YYYY-MM-DD'
                        }"
                        :model-config="{
                          type: 'string',
                          mask: 'YYYY-MM-DD'
                        }"
                      >
                        <template v-slot="{ inputValue, inputEvents }">
                          <input
                            type="text"
                            :value="inputValue"
                            v-on="inputEvents"
                            placeholder="날짜를 선택해 주세요."
                            readonly
                          />
                        </template>
                      </date-picker>
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl essen">구매 희망가</div>
                  <div class="form_in">
                    <div class="inline">
                      <label class="input">
                        <input
                          type="number"
                          inputmode="decimal"
                          pattern="\d*"
                          placeholder="숫자만 입력해 주세요."
                          :min="0"
                          v-model="params.minPrice"
                        />
                      </label>
                      <span class="tilde">~</span>
                      <label class="input">
                        <input
                          type="number"
                          inputmode="decimal"
                          pattern="\d*"
                          placeholder="숫자만 입력해 주세요."
                          :min="0"
                          v-model="params.maxPrice"
                        />
                      </label>
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">검색어 설정</div>
                  <div class="form_in">
                    <label class="input">
                      <input
                        type="text"
                        placeholder="검색어, 검색어, 검색어, 검색어, 검색어"
                        v-model="params.searchWord"
                        :maxlength="100"
                      />
                    </label>
                    <div class="hint">
                      * 검색어, 식으로 검색어 뒤에 콤마를 찍어서 입력해주세요.
                    </div>
                    <div class="hint">
                      * 검색어는 5개 미만으로 등록해야 검색 결과가 좋습니다.
                    </div>
                    <div class="hint">
                      * 검색어가 너무 길면 검색기간이 길어지거나 검색이 되지
                      않을수 있습니다.
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="con_btn">
            <!-- 20210809 주석처리 -->
            <label class="checkbox">
              <input
                type="checkbox"
                :true-value="'Y'"
                :false-value="'N'"
                v-model="params.publicYn"
                :checked="params.publicYn === 'Y'"
              />
              <span class="label"
                ><span
                  >이 조건을 파티 희망 게시판에 공개 노출합니다.</span
                ></span
              >
            </label>
            <div class="btn_wrap">
              <button class="btn bo" @click="fnDelete">삭제</button>
              <button class="btn" @click="fnSave">저장</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { componentState } from './index.js'
export default {
  name: 'my-page-party-noti-write-index',
  setup() {
    return { ...componentState() }
  }
}
</script>

<style scoped></style>
